<script>
import AdminLayout from '@layouts/admin-main'
import MemberNav from '@components/admin/member-nav'
import { fetchInviteRelationList } from '@apis/admin/member'

export default {
  page: {
    title: 'Admin::MemberInviteRelationList',
    meta: [{ name: 'description', content: 'Admin::MemberInviteRelationList' }],
  },
  components: { AdminLayout, MemberNav },
  data() {
    return {
      loading: false,
      tree: [],
      width: 'auto',
      input_width: '',
      tree_props: {
        label: 'child_user_id',
        children: 'children',
      },
    }
  },
  watch: {
    $route(to, from) {
      this.page = this.$route.query.page || 1
      this.loadList().catch((e) => this.$toasted.error(e.message))
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.page = this.$route.query.page || 1
      Promise.all([this.loadList()])
        .catch((e) => this.$toasted.error(e.message))
        .finally(() => {
          this.loading = false
        })
    },
    async loadList() {
      this.loading = true
      const ret_obj = await fetchInviteRelationList({
        ...this.$route.params,
        ...this.$route.query,
        parent_seq: this.$route.params.member_seq,
        no_paging: 1,
      })

      this.tree = this.flatToHierarchy(ret_obj.data)
    },
    flatToHierarchy(flat) {
      const root_seq = this.$route.params.member_seq * 1
      const root = {
        child_user_id: this.$t('member_invite_relation_list.yourself'),
        child_seq: root_seq,
        child_is_alive: 'Y',
      }
      const roots = [root]
      const all = { [root_seq]: root }

      flat.forEach((item) => {
        all[item.child_seq] = item
      })

      Object.keys(all).forEach((child_seq) => {
        const item = all[child_seq]

        if (item.child_inviter_seq in all) {
          const p = all[item.child_inviter_seq]
          if (!('children' in p)) {
            this.$set(p, 'children', [])
          }
          p.children.push(item)
        }
      })

      return roots
    },
    handleSubmit() {
      this.width = this.input_width
    },
    handleNodeClick(data) {
      if (data.child_is_alive === 'Y')
        this.$router.push({
          name: 'admin-member-catalog',
          params: { member_seq: data.child_seq },
        })
    },
  },
}
</script>

<template>
  <AdminLayout v-loading.fullscreen="loading">
    <MemberNav></MemberNav>
    <fieldset v-if="0">
      <form :class="[$style.fr]" @submit.prevent="handleSubmit">
        <input
          v-model="input_width"
          type="text"
          :class="[$style.inputTypeText, $style.w80]"
          :placeholder="$t('member_invite_relation_list.area')"
        />
        <span :class="[$style.button, $style.black]"
          ><input
            type="submit"
            :value="$t('member_invite_relation_list.designation')"
        /></span>
      </form>
    </fieldset>
    <div :class="[$style.container]">
      <!-- <HierarchicalStructure
        :style="{ width }"
        :class="[$style.centered]"
        :items="tree"
      >
        <template v-slot="{ scope }">
          <router-link
            :class="{ [$style.deleted]: !scope.child_is_alive }"
            :to="{
              name: 'admin-member-catalog',
              params: { member_seq: scope.child_seq },
            }"
          >
            {{ scope.child_user_id }}
          </router-link>
        </template>
      </HierarchicalStructure> -->
      <el-tree
        :data="tree"
        :props="tree_props"
        :class="[$style.nodeTree]"
        @node-click="handleNodeClick"
      >
        <template slot-scope="{ node, data }">
          <div
            :class="[
              $style.childrenLabel,
              $style[
                `depth-${
                  typeof data.depth === 'undefined' ? 'root' : data.depth % 4
                }`
              ],
              {
                [$style.delete]: data.child_is_alive !== 'Y',
              },
            ]"
          >
            {{ node.label }}
          </div>
        </template>
      </el-tree>
    </div>
  </AdminLayout>
</template>

<style lang="scss" module>
@import '@src/design/default.scss';
@import '@src/design/admin.scss';
@import '@src/design/font.scss';
@import '@src/design/button.scss';

ul li a.deleted {
  text-decoration: line-through !important;
  border-color: red;
}
.container {
  display: flex;
  flex-direction: column; /* put this if you want to stack elements vertically */
  max-height: 800px;
  overflow: scroll;
}
.centered {
  margin: 0 auto;
}
.childrenLabel {
  padding: 5px 10px;
  color: #eee;
  border: 1px solid #ccc;
  border-radius: 5px;
}
.delete {
  text-decoration: line-through;
  animation: danger-blink 1s infinite; /* IE 10+, Fx 29+ */
}

@-webkit-keyframes danger-blink {
  0%,
  49% {
    color: red;
    background-color: #fff;
  }
  50%,
  100% {
    color: #fff;
    background-color: red;
  }
}
.nodeTree span {
  font-size: 18px;
}

.depth-root {
  background-color: #f40552;
}

.depth-0 {
  background-color: #d8c593;
}
.depth-1 {
  background-color: #dd7631;
}
.depth-2 {
  background-color: #708160;
}
.depth-3 {
  background-color: #bb3b0e;
}
</style>
